// extracted by mini-css-extract-plugin
module.exports = {"numeric-input":"NumericInput_numeric-input__1Jguy","no-margin":"NumericInput_no-margin__3_5vX","strike":"NumericInput_strike__dT_Zm","input":"NumericInput_input__W6a69"};